import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import ShowTaxrates from '../components/taxrate/ShowTaxrates';
import { clearAuthErrors, fetchTaxrates, disableTaxrate, clearTaxrateErrors } from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  taxrates: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class TaxratePage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  // TODO: review this, why duplication on each Container - gabo
  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    this.props.dispatch(clearTaxrateErrors());
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.taxrates.search && this.props.taxrates.search.length > 0) {
      query.search = this.props.taxrates.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/taxrate', query });
    } else {
      this.props.dispatch(fetchTaxrates(query));
    }
  }
  onTaxrateDisable(data) {
    this.props.dispatch(disableTaxrate(data));
  }
  handleSearchChange(e) {
    const taxrates = this.props.taxrates;
    const query = this.props.query;
    const router = this.props.router;
    const nextZipcode = e.target.value;
    taxrates.search = nextZipcode;
    this.setState({
      taxrates,
    });
    if (nextZipcode.length > 0) {
      query.search = nextZipcode;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/taxrate', query });
    this.props.dispatch(fetchTaxrates(query));
  }
  navigation(route) {
    // add search to url
    this.props.dispatch(fetchTaxrates(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="taxrate component" style={authPage}>
        <h2>Tax Rates</h2>
        <div className="content">
          <div className="action-buttons">
            <Link to="/taxrate/new">
              <RaisedButton
                label="Add New Tax Rate"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Zipcode"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.taxrates.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.taxrates.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowTaxrates
            taxrates={this.props.taxrates}
            onTaxrateDisable={data => this.onTaxrateDisable(data)}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.taxrates.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

TaxratePage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

TaxratePage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    taxrates: state.taxrates,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(TaxratePage));



// WEBPACK FOOTER //
// ./src/containers/TaxratePage.js